import React from 'react';
import { Card, Box, Text } from '../core';

export const GraphEvents = ({ events }) =>
  events?.length
    ? events?.map((x) => (
        <Card variant="small" key={x.description}>
          <Text color="lightBlue">{x.title}</Text>
          <Box mb={1} />
          <Text sx={{ 'white-space': 'pre-line' }}>{x.description}</Text>
        </Card>
      ))
    : '';
